export default "__VITE_ASSET__65616a95__"